module.exports = __webpack_public_path__ + "static/loading-d7f0f6653811f668530d0021c0b3de17.jpg";